module.exports = __webpack_public_path__ + "static/0079-8fb290bec7eea39ac585da134f8fb9d4.png";